module.exports = __webpack_public_path__ + "img/agent.cca27592.png";